// extracted by mini-css-extract-plugin
export default {"displayNone":"custom-time_displayNone__04oZX"};